<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="acknowledgement">
<h1>Acknowledgment</h1>
<br/><p style="text-indent:00em;">I must start by thanking my former student, Raj, for providing the initial inspiration that would lead to the writing of this book. Look what you made me do, my friend.</p>
<br/><p style="text-indent:00em;">Heather and Trish, thank you so very much for your investment in my confidence. You never once let me falter and for that, I thank you.</p>
<br/><p style="text-indent:00em;">Most importantly, I owe a great deal of thanks to the woman who has had to tolerate every ‘what do you think about this word?’ and ‘do you think this sounds good?’ that I dished out. And let us not forget, ‘Will you please read this and tell me what you think?’ My dear, your patience knows no end. Thank you.</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch003.vue?f44bf980